import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect, useSelector } from 'react-redux';
import { find, get, isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { CircularProgress, Dialog, FlatButton, FontIcon, MenuItem, Paper, RaisedButton, SelectField, TextField } from 'material-ui';
import { useForm, Controller } from 'react-hook-form/dist/index.ie11';
import styles from 'styles/TBenefits';
// import WomanLaptop from '../../images/WomanLaptop';
import Thinking from '../../images/Thinking';
import { createApprovalRequest } from '../../actions/ApprovalRequests';
import KTitle from '../../components/KJRN/KTitle';
import { custom } from '../../utils/Api';
import { getWorkingHoursToday } from '../../sites/time/api';
import { numberOfWorkingDays } from '../../sites/time/components/holidays';
import pallet from '../../constants/colors';
import useVacationStatusChecker from '../../sites/time/useVacationStatusChecker';
import { fetch } from '../../actions/EmployeeHoliday';

const errorStyle = {
  color: 'red',
  fontSize: '12px',
  margintop: 20,
};

const useWorkingHours = (detailId) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  useEffect(() => {
    const fetchWorkingHours = async () => {
      setLoading(true);
      const result = get(await custom(getWorkingHoursToday(detailId)), 'data.value[0].HrsPrDay', 0);
      setData(result);
      setLoading(false);
    };
    if (detailId) {
      fetchWorkingHours();
    }
  }, [detailId]);
  return { loading, data };
};
const THolidayRequest = ({
  loading, submitRequest, DefaultEmployeeDetailID, holidayCheckInfo, fetchHoliday,
}) => {
  const [showDialog, setShowDialog] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [warningText, setWarningText] = useState('');
  const [warningType, setWarningType] = useState('');
  const [timeError, setTimeError] = useState('');
  const [showConfirmButton, setShowConfirmButton] = useState(false);

  const { validateHolidayStatus } = useVacationStatusChecker(holidayCheckInfo);

  const openDialog = () => setShowDialog(true);
  const closeDialog = () => {
    setShowConfirmButton(false);
    setShowDialog(false);
  };
  const { data: workingHours } = useWorkingHours(DefaultEmployeeDetailID);
  const {
    profileReducer: { employeeDetailOrgList },
    WebValuesReducer: { valuesByKey }
  } = useSelector(state => state);
  const {
    handleSubmit,
    watch,
    errors,
    control,
  } = useForm();
  const employeeDetailOrg = find(employeeDetailOrgList, d => d.EmployeeDetailID === DefaultEmployeeDetailID);
  const timeOfficerId = get(employeeDetailOrg, 'EmployeeOfficerTimeID', 0);
  const timeOfficerName = get(employeeDetailOrg, 'EmployeeOfficerTimeName', '');
  const showTimeOfficerSelect = get(valuesByKey, ['HolidayRequest.TimeOfficerApproval', 'Value']) === 'true';
  const managerName = get(employeeDetailOrg, 'ManagerName', '');
  const PeriodBegda = watch('PeriodBegda');
  const PeriodEndda = watch('PeriodEndda');
  const Duration = watch('Duration');

  const onSubmit = async (data) => {
    setIsDisabled(true);
    const numOfDays = numberOfWorkingDays(moment(PeriodBegda), moment(PeriodEndda));
    const reqHours = numOfDays * Duration;
    const isUnpaidVacation = data.ConnectedID === 1;
    let type;
    let text;
    if (isUnpaidVacation) {
      setWarningText('');
      setWarningType('success');
    } else {
      ({ type, text } = await validateHolidayStatus(reqHours));
      setWarningText(text);
      setWarningType(type);
    }
    if (type === 'success' || isUnpaidVacation) {
      submitRequest(data, closeDialog);
    } else if (type === 'warning') {
      setShowConfirmButton(true);
    }
    setIsDisabled(false);
  };

  useEffect(() => {
    fetchHoliday();
  }, []);

  useEffect(() => {
    setTimeError('');
    setWarningText('');
    setShowConfirmButton(false);
    if (PeriodBegda && PeriodEndda && Duration) {
      const isClockOutBeforeIn = moment(PeriodEndda).isBefore(moment(PeriodBegda));
      const isBeforeCurrentDate = moment(PeriodBegda).isBefore(moment(), 'day');
      if (isBeforeCurrentDate) {
        setTimeError('holidayApprovalRequest.timeError.beforeCurrentDate');
        setIsDisabled(true);
      } else if (isClockOutBeforeIn) {
        setTimeError('holidayApprovalRequest.timeError');
        setIsDisabled(true);
      } else {
        setTimeError('');
        setIsDisabled(false);
      }
    }
  }, [PeriodBegda, PeriodEndda, Duration]);

  const actions = [
    <FlatButton
      label={<FormattedMessage id="alert.cancel" />}
      disabled={loading}
      secondary
      onClick={closeDialog}
    />,
    !showConfirmButton ? (
      <RaisedButton
        label={<FormattedMessage id="submit" />}
        icon={<FontIcon className="material-icons">send</FontIcon>}
        disabled={loading || !isEmpty(errors) || isDisabled}
        primary
        // onClick={handleSubmit(data => submitRequest(data, closeDialog))}
        onClick={handleSubmit(onSubmit)}
      />
    ) : (
      <RaisedButton
        label={<FormattedMessage id="alert.ok" />}
        icon={<FontIcon className="material-icons">send</FontIcon>}
        disabled={loading || !isEmpty(errors) || isDisabled}
        primary
        onClick={handleSubmit(data => submitRequest(data, closeDialog))}
      />
    ),
  ];
  return (
    <div style={styles.container} data-cy="holiday-request">
      <Dialog
        open={showDialog}
        actions={actions}
        contentStyle={{
          overflow: 'hidden',
          maxWidth: 500,
          width: '100%',
        }}
        bodyStyle={{
          overflowY: 'auto',
        }}
        modal
      >
        {loading ? (
          <div
            style={{
              backgroundColor: 'rgba(0, 0, 0, 0.34)',
              position: 'absolute',
              zIndex: 10,
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Paper
              style={{
                padding: 32,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <CircularProgress style={{ marginBottom: 24 }} size={100} />
              <FormattedMessage id="sending.message" />
            </Paper>
          </div>
        ) : null}
        <KTitle
          style={{
            marginLeft: 0,
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
          }}
          title={(
            <React.Fragment>
              <FontIcon
                style={{
                  marginRight: 6, fontSize: 28, color: 'inherit',
                }}
                className="material-icons"
              >school
              </FontIcon>
              <FormattedMessage id="dash.title.holidayApprovalRequest" />
            </React.Fragment>
          )}
          subtitleStyle={{ margin: 0, fontSize: 12, lineHeight: '1' }}
          subtitle={(
            <React.Fragment>
              <FormattedMessage id="holidayApprovalRequest.description" />
            </React.Fragment>
          )}
        />
        <form style={{ marginBottom: 32 }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Controller
              as={(
                <TextField
                  fullWidth
                  floatingLabelFixed
                  floatingLabelText={<FormattedMessage id="approvalRequest.form.description" />}
                  errorText={errors.RequestDescription ? <FormattedMessage id="editPanel.required" /> : ''}
                  multiLine
                  rows={3}
                />
              )}
              name="RequestDescription"
              control={control}
              defaultValue=""
              rules={{ required: true }}
            />
            <Controller
              as={(
                <TextField
                  fullWidth
                  type="date"
                  min={new Date().toISOString().split('T')[0]}
                  floatingLabelFixed
                  floatingLabelText={<FormattedMessage id="approvalRequest.form.from" />}
                  errorText={errors.PeriodBegda ? <FormattedMessage id="editPanel.required" /> : ''}
                />
              )}
              name="PeriodBegda"
              control={control}
              defaultValue=""
              rules={{ required: true }}
            />
            <Controller
              as={(
                <TextField
                  fullWidth
                  type="date"
                  min={new Date().toISOString().split('T')[0]}
                  floatingLabelFixed
                  floatingLabelText={<FormattedMessage id="approvalRequest.form.to" />}
                  errorText={errors.PeriodEndda ? <FormattedMessage id="editPanel.required" /> : ''}
                />
              )}
              name="PeriodEndda"
              control={control}
              defaultValue=""
              rules={{ required: true }}
            />
            {timeError && <div style={errorStyle}><FormattedMessage id={timeError} /></div>}
            <Controller
              render={({
                onChange, onBlur, value, name, ref,
              }) => (
                <SelectField
                  name={name}
                  onBlur={onBlur}
                  inputRef={ref}
                  onChange={(_, __, val) => onChange(val)}
                  fullWidth
                  floatingLabelFixed
                  value={value}
                  floatingLabelText={<FormattedMessage id="time.Type" />}
                >
                  <MenuItem primaryText={<FormattedMessage id="holiday" />} value={0} key={0} />
                  <MenuItem primaryText={<FormattedMessage id="holiday.unpaid" />} value={1} key={1} />
                </SelectField>
              )}
              name="ConnectedID"
              control={control}
              defaultValue={0}
            />
            <Controller
              as={(
                <TextField
                  fullWidth
                  type="number"
                  floatingLabelFixed
                  floatingLabelText={<FormattedMessage id="approvalRequest.form.hoursPerDay" />}
                  min={0}
                  step={0.01}
                />
              )}
              defaultValue={workingHours}
              name="Duration"
              control={control}
              errorText={warningText}
              errorStyle={{ ...(warningType === 'warning' && { color: pallet.warningColor }) }}
              rules={{ required: true }}
            />
            {(showTimeOfficerSelect && timeOfficerId) ?
              <Controller
                render={({
                  onChange, onBlur, value, name, ref,
                }) => (
                  <SelectField
                    name={name}
                    onBlur={onBlur}
                    inputRef={ref}
                    onChange={(_, __, val) => onChange(val)}
                    fullWidth
                    floatingLabelFixed
                    value={value}
                    floatingLabelText={<FormattedMessage id="time.Approver" />}
                  >
                    <MenuItem primaryText={managerName} value={0} key={0} />
                    <MenuItem primaryText={timeOfficerName} value={timeOfficerId} key={timeOfficerId} />
                  </SelectField>
                )}
                name="RequestApproverID"
                control={control}
                defaultValue={timeOfficerId}
              /> : null}
          </div>
        </form>
      </Dialog>
      <div
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* <WomanLaptop /> */}
        <Thinking />
        <div
          style={{
            padding: 8,
            marginBottom: 12,
            marginTop: 12,
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <FontIcon style={{ marginRight: 8 }} color={pallet.infoColor} className="material-icons" >info</FontIcon>
          <FormattedMessage id="holidayApprovalRequest.description" />
        </div>
        <RaisedButton
          primary
          style={{ marginBottom: 12 }}
          onClick={openDialog}
          data-cy="holiday-request-button"
          label={<FormattedMessage id="holidayApprovalRequest.button" />}
        />
      </div>
    </div>
  );
};

THolidayRequest.propTypes = {
  loading: PropTypes.bool.isRequired,
  submitRequest: PropTypes.func.isRequired,
  DefaultEmployeeDetailID: PropTypes.number.isRequired,
  holidayCheckInfo: PropTypes.shape({}).isRequired,
  fetchHoliday: PropTypes.func.isRequired,
};

THolidayRequest.defaultProps = {
};

export default connect(
  ({ approvalRequestReducer, loginReducer, EmployeeHolidayReducer }) => ({
    ...approvalRequestReducer,
    DefaultEmployeeDetailID: get(loginReducer, 'user.DefaultEmployeeDetailID', 0),
    holidayCheckInfo: EmployeeHolidayReducer.holidayCheckInfo,
  }),
  dispatch => ({
    submitRequest: (data, cb) => dispatch(createApprovalRequest({
      ...data,
      EmployeeDetailApprovalRequestType: 'EmployeeDetailVacationsHandler',
      RequestTitle: 'Orlofsbeiðni/Vacation request',
    }, cb)),
    fetchHoliday: () => dispatch(fetch()),
  }),
)(THolidayRequest);



// WEBPACK FOOTER //
// ./src/containers/tiles/THolidayRequest.js